export const toggleForm = () => {
  // Open/Close Search Form
  const Body = document.body
  const btnOpenForm = document.querySelector('.right_btns a.searchHeader')
  const Form = document.querySelector('.popin_search_on_site')
  const btnCloseForm = document.querySelector('.popin_search_on_site a.close_search')

  btnOpenForm.addEventListener('click', function () {
    event.preventDefault()

    Body.classList.add('popin_open')
    Form.classList.add('is_open')
    Form.style.display = 'flex'
  })

  btnCloseForm.addEventListener('click', function () {
    event.preventDefault()

    Body.classList.remove('popin_open')
    Form.classList.remove('is_open')
    Form.style.display = 'none'
  })
}
